export const REGISTRATION_FORM = [
  {
    label: 'register.customer.step1.title',
    subTitle: 'Enter the details of your client.',
    sections: [
      {
        label: 'register.customer.personal.heading',
        type: 'input',
        fields: [
          {
            name: 'firstName',
            key: 'register.customer.form.firstname',
            component: 'text',
            required: true,
            validation: /^\S.{0,39}$/,
            isCoralogixMasked:true
          },
          {
            name: 'lastName',
            key: 'register.customer.form.lastname',
            component: 'text',
            required: true,
            validation: /^\S.{0,39}$/,
            isCoralogixMasked:true
          },
          {
            name: 'dateOfBirth',
            key: 'register.customer.form.dateofbirth',
            component: 'dob',
            required: true,
            isCoralogixMasked:true
          }
        ]
      },
      {
        label: 'register.customer.contact.heading',
        type: 'input',
        fields: [
          {
            name: 'email',
            key: 'register.customer.form.email',
            component: 'text',
            required: true,
            validation: /^(([a-zA-Z0-9!#$%&'*+-\/=?^_`{|]{1,64})([@]{1})([a-zA-Z0-9-.]{2,160})([.]{1})([a-zA-Z0-9-.]{2,24}))$/i, // eslint-disable-line
            doesCustomerAlreadyExistsCheck: true,
            isCoralogixMasked:true
          },
          {
            name: 'mobile',
            key: 'register.customer.form.mobile',
            component: 'combo',
            required: true,
            validation: /^(\+)?([0-9]){10,16}$/i,
            reference: 'dialing',
            isCoralogixMasked:true
          }
        ]
      },
      {
        label: 'register.customer.employment.heading',
        type: 'input',
        fields: [
          {
            name: 'employmentStatus',
            key: 'register.customer.form.employmentStatus',
            component: 'select',
            required: true,
            reference: 'employmentStatus'
          },
          {
            name: 'industryType',
            key: 'register.customer.form.industry',
            component: 'select',
            required: true,
            reference: 'industryType',
            condition: {
              name: 'isIndustryDependent',
              value: [true]
            },
          }
        ],
        link: 'register.customer.form.why.need.this',
        linkDescription: 'register.customer.form.why.need.this.description'
      },
      {
        type: 'input',
        fields: [
          {
            name: 'clientReferenceId',
            key: 'register.customer.form.clientReferenceId',
            component: 'text',
            required: false,
            validation: /^\S.{0,199}$/
          }
        ],
        referenceDetails: 'register.customer.form.clientReference.details'
      }
    ]
  },
  {
    label: 'register.customer.step2.title',
    sections: [
      {
        label: 'register.customer.address.heading',
        type: 'input',
        fields: [
          {
            name: 'address',
            key: 'register.customer.form.address',
            component: 'address',
            required: true,
            isCoralogixMasked:true
          },
          {
            name: 'isJoint',
            key: 'register.customer.form.joint',
            component: 'checkbox',
            required: false
          },
          {
            name: 'addressUSAStateDisclaimer',
            component: 'label',
            required: false
          }
        ]
      },
      {
        label: 'register.customer.joint.personal.heading',
        type: 'input',
        isJoint: true,
        fields: [
          {
            name: 'jointFirstNames',
            key: 'register.customer.form.firstname',
            component: 'text',
            required: false,
            validation: /^\S.{0,39}$/,
            isJoint: true,
            isCoralogixMasked:true
          },
          {
            name: 'jointLastName',
            key: 'register.customer.form.lastname',
            component: 'text',
            required: false,
            validation: /^\S.{0,39}$/,
            isJoint: true,
            isCoralogixMasked:true
          },
          {
            name: 'jointDateOfBirth',
            key: 'register.customer.form.dateofbirth',
            component: 'dob',
            required: false,
            isJoint: true,
            isCoralogixMasked:true
          }
        ]
      },
      {
        label: 'register.customer.contact.heading',
        type: 'input',
        isJoint: true,
        fields: [
          {
            name: 'jointEmail',
            key: 'register.customer.form.email',
            component: 'text',
            required: false,
            validation: /^(([a-zA-Z0-9!#$%&'*+-\/=?^_`{|]{1,64})([@]{1})([a-zA-Z0-9-.]{2,160})([.]{1})([a-zA-Z0-9-.]{2,24}))$/i, // eslint-disable-line
            isJoint: true,
            doesCustomerAlreadyExistsCheck: true,
            isCoralogixMasked:true
          },
          {
            name: 'jointMobile',
            key: 'register.customer.form.mobile',
            component: 'combo',
            required: true,
            validation: /^(\+)?([0-9]){10,16}$/i,
            reference: 'dialing',
            isJoint: true,
            isCoralogixMasked:true
          }
        ]
      },
      {
        label: 'register.customer.employment.heading',
        type: 'input',
        isJoint: true,
        fields: [
          {
            name: 'jointEmploymentStatus',
            key: 'register.customer.form.employmentStatus',
            component: 'select',
            required: true,
            reference: 'employmentStatus',
            isJoint: true
          },
          {
            name: 'jointIndustryType',
            key: 'register.customer.form.industry',
            component: 'select',
            required: true,
            reference: 'industryType',
            isJoint: true,
            condition: {
              name: 'isIndustryDependentJoint',
              value: [true]
            }
          }
        ],
        link: 'register.customer.form.why.need.this',
        linkDescription: 'register.customer.form.why.need.this.description'
      },
      {
        label: 'register.customer.joint.address.heading',
        type: 'input',
        isJoint: true,
        fields: [
          {
            name: 'jointAddress',
            key: 'register.customer.form.address',
            component: 'address',
            required: true,
            isJoint: true,
            isCoralogixMasked:true
          },
          {
            name: 'jointAddressUSAStateDisclaimer',
            component: 'label',
            required: false
          }
        ]
      },
    ]
  },
  {
    label: 'register.customer.step4.title',
    sections: [
      {
        label: 'register.customer.confirm.heading',
        type: 'summary',
        summaries: [
          {
            key: 'register.customer.summary.fullname',
            combine: ['firstName', 'lastName'],
            isCoralogixMasked:true
          },
          {
            key: 'register.customer.summary.dateofbirth',
            combine: ['dateOfBirth'],
            format: 'date',
            isCoralogixMasked:true
          },
          {
            key: 'register.customer.summary.email',
            combine: ['email'],
            isCoralogixMasked:true
          },
          {
            key: 'register.customer.summary.mobile',
            combine: ['mobile'],
            isCoralogixMasked:true
          },
          {
            key: 'register.customer.summary.employment.status',
            combine: ['employmentStatus']
          },
          {
            key: 'register.customer.summary.employment.industry',
            combine: ['industryType'],
            condition: {
              name: 'isIndustryDependent',
              value: [true]
            }
          },
          {
            key: 'register.customer.summary.client.reference.id',
            combine: ['clientReferenceId'],
            using: ', '
          },
          {
            key: 'register.customer.summary.country',
            combine: ['address.country'],
            isCoralogixMasked:true
          },
          {
            key: 'register.customer.summary.address',
            combine: ['address.line1', 'address.city', 'address.county', 'address.postcode'],
            using: ', ',
            isCoralogixMasked:true
          }
        ]
      },
      {
        label: 'register.customer.confirm.joint.heading',
        type: 'summary',
        isJoint: true,
        summaries: [
          {
            key: 'register.customer.summary.fullname',
            combine: ['jointFirstNames', 'jointLastName'],
            isCoralogixMasked:true
          },
          {
            key: 'register.customer.summary.dateofbirth',
            combine: ['jointDateOfBirth'],
            format: 'date',
            isCoralogixMasked:true
          },
          {
            key: 'register.customer.summary.email',
            combine: ['jointEmail'],
            isCoralogixMasked:true
          },
          {
            key: 'register.customer.summary.mobile',
            combine: ['jointMobile'],
            isCoralogixMasked:true
          },
          {
            key: 'register.customer.summary.employment.status',
            combine: ['jointEmploymentStatus']
          },
          {
            key: 'register.customer.summary.employment.industry',
            combine: ['jointIndustryType'],
            condition: {
              name: 'isIndustryDependentJoint',
              value: [true]
            }
          },
          {
            key: 'register.customer.summary.country',
            combine: ['jointAddress.country'],
            isCoralogixMasked:true
          },
          {
            key: 'register.customer.summary.address',
            combine: ['jointAddress.line1', 'jointAddress.city', 'jointAddress.county', 'jointAddress.postcode'],
            using: ', ',
            isCoralogixMasked:true
          }
        ]
      },
      {
        type: 'input',
        fields: [
          {
            name: 'dataTerms',
            key: 'register.customer.summary.dataterms',
            component: 'checkbox',
            required: true,
          }
        ]
      }
    ]
  }
];
